import { render, staticRenderFns } from "./CollapsibleTextAreaField.vue?vue&type=template&id=59d65c4a"
import script from "./CollapsibleTextAreaField.vue?vue&type=script&lang=js"
export * from "./CollapsibleTextAreaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports